exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-app {\n  height: 100%;\n  display: flex;\n  flex-direction: column; }\n\n.app-content {\n  flex: 1 0 auto;\n  background-color: #f5f5f5; }\n\n.app-footer {\n  flex-shrink: 0; }\n\n.toast-custom {\n  background-image: linear-gradient(#4a9462, #4a9462); }\n", ""]);

// exports
